export const CONTENTFUL_CACHE_STORAGE_KEY = 'contentful-content-type-entries';
export const CONTENTFUL_CACHE_WEB_STORAGE_DB_NAME = 'contentful-content-type-entries-db';
